import { PropsWithChildren, createContext, useContext, Dispatch } from 'react';
import { AxiosResponse } from 'axios';
import { SmartConnector, SmartConnectorExtended } from './types';
import { RunSmartConnectorModalProps } from './components/RunSmartConnectorModal';

type SmartConnectorsCtx = {
  smartConnectors: SmartConnector[];
  loadingSmartConnectors: boolean;
  totalSmartConnectors: number;
  search: string;
  pageNumber: number;
  pageSize: number;
  sort: string;
  smartConnectorDispatch: Dispatch<any>;
  handleChangePageNumber: (pageNumber: number) => void | undefined;
  smartConnectorIdForDeletion: any;
  createModalProps: any;
  handleChangePageSize: (pageSize: number) => void | undefined;
  handleChangeSearch: (search: string) => void | undefined;
  handleChangeSort: (column: string, direction: 'asc' | 'desc') => void;
  handleDeleteSmartConnector: (id: string) => void | undefined;
  handleDuplicateSmartConnector: (
    id: string | null
  ) => Promise<void> | Promise<AxiosResponse<any, any>> | void | undefined;
  handlePatchSmartConnector: (
    id: string,
    patch: any
  ) => void | Promise<void> | Promise<any>;
  runSmartConnectorModalProps: RunSmartConnectorModalProps | null;
  showRunSmartConnectorModal: (props: {
    smartConnector: SmartConnector | SmartConnectorExtended;
    isDryRun: boolean;
    canSkipDiffCheck: boolean;
  }) => void;
  showCreateModal: () => void;
};

const context = createContext<SmartConnectorsCtx>({
  smartConnectors: [],
  loadingSmartConnectors: false,
  totalSmartConnectors: 0,
  search: '',
  pageSize: 10,
  pageNumber: 1,
  sort: '',
  smartConnectorDispatch: () => {},
  smartConnectorIdForDeletion: null,
  createModalProps: null,
  handleChangePageNumber: () => {},
  handleChangePageSize: () => {},
  handleChangeSearch: () => {},
  handleChangeSort: () => {},
  handleDeleteSmartConnector: () => {},
  handleDuplicateSmartConnector: () => {},
  handlePatchSmartConnector: () => {},
  runSmartConnectorModalProps: null,
  showRunSmartConnectorModal: () => {},
  showCreateModal: () => {},
});

export const useSmartConnectorsContext = () => {
  return useContext(context);
};

export const SmartConnectorsProvider = ({
  children,
  value,
}: PropsWithChildren<{ value: SmartConnectorsCtx }>) => {
  return <context.Provider value={value}>{children}</context.Provider>;
};
